<template>
  <div>
    <div class="hit-input-group">
      <div class="hit-input-group-addon">
        <hit_icon :id="'list'" />
      </div>
      <input type="text"  class="hit-form-control" v-model="edit.value" v-on:change="change()" v-bind:placeholder="$tc('message.noEntry',1)">
    </div>
  </div>
</template>

<script>

export default{
  props: { edit: Object},
  data () {
    return {
      data: this.edit.value
    }
  },
  methods: {
    change () {
      if (!this.edit.value.length) { return false }

      this.$store.dispatch('set_change_board', {index: this.edit.row, data: {name: this.edit.value} })
    }
  }
}
</script>
